import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-cover-modal',
  templateUrl: './change-cover-modal.component.html',
  styleUrls: ['./change-cover-modal.component.scss']
})
export class ChangeCoverModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
